import React from 'react';
import { FaRobot, FaCloud, FaNetworkWired } from 'react-icons/fa';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/Technology.css';

const Technology = () => {
  useScrollAnimation();

  const technologies = [
    {
      icon: <FaRobot size={24} />,
      title: '인공지능 기술',
      description: 'YOLO, LSTM 기반의 객체 인식 및 예측 시스템',
    },
    {
      icon: <FaCloud size={24} />,
      title: '클라우드 플랫폼',
      description: '실시간 데이터 수집 및 분석을 위한 클라우드 인프라',
    },
    {
      icon: <FaNetworkWired size={24} />,
      title: 'IoT 솔루션',
      description: 'LoRa 기반의 저전력 장거리 통신 네트워크',
    },
  ];

  const patents = [
    {
      title: '돼지 생육 모니터링 시스템 및 방법',
      number: '10-2024-0027196',
      date: '2024.02.26',
      description: 'AI 기반 돼지 건강 상태 실시간 모니터링 시스템',
    },
    {
      title: '돼지 펀딩 중개플랫폼 시스템',
      number: '10-2024-0027197',
      date: '2024.02.26',
      description: '투명한 축산 투자 플랫폼',
    },
    {
      title: '인공지능 기반 말벌 퇴치 장치',
      number: '10-2024-0128517',
      date: '2024.09.23',
      description: 'AI 영상인식 기반 친환경적 말벌 퇴치 시스템',
    },
  ];

  const copyrights = [
    {
      title: '피그팜 농장주 앱',
      number: 'C-2024-006649',
      date: '2024.02.26',
      description: '농장주용 모바일 애플리케이션',
    },
    {
      title: '피그팜 관리자 앱',
      number: 'C-2024-006650',
      date: '2024.02.26',
      description: '관리자용 모바일 애플리케이션',
    },
  ];

  return (
    <section className="technology-section" id="technology">
      <div className="technology-container">
        <h2 className="technology-section-title fade-in" id="tech-intro">
          기술력 소개
        </h2>

        <div className="technology-tech-grid">
          {technologies.map((tech, index) => (
            <div key={index} className="technology-tech-card slide-in-up">
              <div className="technology-tech-icon">{tech.icon}</div>
              <h3>{tech.title}</h3>
              <p>{tech.description}</p>
            </div>
          ))}
        </div>

        <h2 className="technology-section-title fade-in" id="tech-status">
          핵심 기술 및 서비스
        </h2>

        <div className="technology-tech-grid">
          <div className="technology-tech-card slide-in-up">
            <div className="technology-tech-icon">
              <i className="fas fa-eye"></i>
            </div>
            <h3>객체 인식 및 추적</h3>
            <p>YOLO 기반 실시간 객체 인식과 BoT-SORT 기반 다중 객체 추적 시스템</p>
          </div>

          <div className="technology-tech-card slide-in-up">
            <div className="technology-tech-icon">
              <i className="fas fa-cube"></i>
            </div>
            <h3>체적 측정 및 분석</h3>
            <p>3D 체적 측정, 성장률 분석 및 정밀한 데이터 분석 솔루션</p>
          </div>

          <div className="technology-tech-card slide-in-up">
            <div className="technology-tech-icon">
              <i className="fas fa-brain"></i>
            </div>
            <h3>AI 기반 행동 분석</h3>
            <p>패턴 분석, 이상 감지 및 Transformer 기반 비행경로 예측</p>
          </div>

          <div className="technology-tech-card slide-in-up">
            <div className="technology-tech-icon">
              <i className="fas fa-tags"></i>
            </div>
            <h3>데이터 서비스</h3>
            <p>고품질 AI 학습 데이터 구축을 위한 전문적인 레이블링 및 수집 서비스</p>
          </div>

          <div className="technology-tech-card slide-in-up">
            <div className="technology-tech-icon">
              <i className="fas fa-desktop"></i>
            </div>
            <h3>실시간 모니터링</h3>
            <p>지능형 실시간 모니터링 및 분석 시스템 구축</p>
          </div>

          <div className="technology-tech-card slide-in-up">
            <div className="technology-tech-icon">
              <i className="fas fa-code"></i>
            </div>
            <h3>AI 모델 개발</h3>
            <p>맞춤형 AI 솔루션 개발 및 구축 서비스</p>
          </div>
        </div>

        <div className="technology-patent-section" id="patent-copyright">
          <h2 className="technology-section-title">특허 및 저작권</h2>
          <div className="technology-patent-grid">
            {patents.map((patent, index) => (
              <div key={index} className="technology-patent-card fade-in">
                <h4>{patent.title}</h4>
                <p>{patent.description}</p>
                <p className="date">
                  특허번호: {patent.number}
                  <br />
                  출원일: {patent.date}
                </p>
              </div>
            ))}
            {copyrights.map((copyright, index) => (
              <div key={`copyright-${index}`} className="technology-patent-card fade-in">
                <h4>{copyright.title}</h4>
                <p>{copyright.description}</p>
                <p className="date">
                  저작권번호: {copyright.number}
                  <br />
                  등록일: {copyright.date}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;
